import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { ObjekteQuerySorterConfig } from 'fa-kt.types';
import { ObjekteService } from '../service';

@Component({
  selector: 'fa-kt-objekte-sorter',
  templateUrl: './objekte-sorter.component.html',
  styleUrls: ['./objekte-sorter.component.css'],
})
export class ObjekteSorterComponent {
  public ObjekteSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public objekte: ObjekteService,
  ) {
    this.ObjekteSorterConfig = ObjekteQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
